// Main Kalki logo mark — local Krishna portrait inside a gold-ringed circle
// with a soft radiant halo behind. Sits above the KALKI wordmark on the
// landing hero. Uses local optimized asset for reliable loading.

export default function KalkiMark({ size = 128 }) {
  return (
    <div className="relative flex items-center justify-center">
      {/* Outer halo */}
      <div
        aria-hidden
        className="absolute rounded-full"
        style={{
          width: size * 1.9,
          height: size * 1.9,
          background:
            "radial-gradient(circle, rgba(223,185,110,0.35) 0%, rgba(223,185,110,0.14) 35%, rgba(223,185,110,0) 70%)",
          filter: "blur(6px)",
        }}
      />
      {/* Gold ring frame */}
      <div
        className="relative rounded-full overflow-hidden"
        style={{
          width: size,
          height: size,
          boxShadow:
            "0 20px 60px -20px rgba(197,160,89,0.7), 0 0 0 1px rgba(255,255,255,0.9), 0 0 0 3px rgba(223,185,110,0.55), 0 0 0 4px rgba(140,107,41,0.35)",
          background: "#FFF7E4",
        }}
      >
        <picture>
          <source srcSet="/krishna-dp.webp" type="image/webp" />
          <img
            src="/krishna-dp.png"
            alt="KALKI companion portrait"
            decoding="async"
            fetchPriority="high"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </picture>
        {/* Inner soft golden vignette to blend with the white theme */}
        <span
          aria-hidden
          className="absolute inset-0 rounded-full pointer-events-none"
          style={{
            background:
              "radial-gradient(circle at 30% 25%, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 40%), radial-gradient(circle at center, rgba(0,0,0,0) 55%, rgba(197,160,89,0.18) 100%)",
          }}
        />
      </div>
    </div>
  );
}
